import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from '../../../../shared/services/logger.service';
import { environment } from '../../environments/environment';
import { Capacitor } from '@capacitor/core';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private http = inject(HttpClient);
  private loggerService = inject(LoggerService);

  private versionCheckUrl = environment.apiUrl + '/api/version';

  async isVersionUpToDate(): Promise<boolean> {
    const appInfo = await this.loggerService.getAppInfo();

    if (!Capacitor.isNativePlatform()) {
      return true;
    }

    if (!appInfo) {
      this.loggerService.logException(new Error('Failed to get app info'), 'VersionCheckService');
      return true;
    }

    try {
      const { version: backendVersion, build: backendBuild } = await firstValueFrom(this.http.get<{ version: string; build: string }>(this.versionCheckUrl));

      const currentVersion = `${appInfo.version}-${appInfo.build}`;
      const serverVersion = `${backendVersion}-${backendBuild}`;

      console.log('currentVersion', currentVersion);
      console.log('backendVersion', serverVersion);

      const versionCompare = this.compareVersions(backendVersion, appInfo.version);
      const backendBuildNum = parseInt(backendBuild || '0', 10);
      const currentBuildNum = parseInt(appInfo.build, 10);
  
      if (versionCompare > 0) return false;
      if (versionCompare === 0 && backendBuildNum > currentBuildNum) return false;
  
      return true;
    } catch (err) {
      this.loggerService.logException(err, 'VersionCheckService');
      return true;
    }
  }

  private compareVersions(v1: string, v2: string): number {
    const parts1 = v1.split('.').map(Number);
    const parts2 = v2.split('.').map(Number);
    const len = Math.max(parts1.length, parts2.length);
  
    for (let i = 0; i < len; i++) {
      const a = parts1[i] || 0;
      const b = parts2[i] || 0;
      if (a > b) return 1;
      if (a < b) return -1;
    }
    return 0;
  }
}
